import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';
import { ForgotPasswordModalComponent } from 'src/app/pages/auth/forgot-password-modal/forgot-password-modal.component';
import { LoginModalComponent } from 'src/app/pages/auth/login-modal/login-modal.component';
import { SignupModalComponent } from 'src/app/pages/auth/signup-modal/signup-modal.component';
import { ConfigService } from '../config/config.service';
import { TokenService } from '../token/token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private tokenServe: TokenService,
    private dialog: MatDialog,
  ) {
  }


  // Open Modals
  openLoginModal(): MatDialogRef<LoginModalComponent> {
    const dialogRef = this.dialog.open(LoginModalComponent, {
      panelClass: 'sign-up',
      minWidth: '350px',
      minHeight: '20vh',
      width: '30vw',
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data?.openSignUp) {
        this.openSignUpModal();
      }

      if (data?.openForgotPassword) {
        this.openForgotPasswordModal()
      }
    });

    return dialogRef;
  }

  openSignUpModal(): MatDialogRef<SignupModalComponent> {
    const dialogRef = this.dialog.open(SignupModalComponent, {
      panelClass: 'sign-up',
      minWidth: '350px',
      minHeight: '20vh',
      width: '30vw',
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data?.openLogin) {
        this.openLoginModal();
      }

      if (data?.openForgotPassword) {
        this.openForgotPasswordModal()
      }
    });

    return dialogRef;
  }

  openForgotPasswordModal(): MatDialogRef<ForgotPasswordModalComponent> {
    const dialogRef = this.dialog.open(ForgotPasswordModalComponent, {
      panelClass: 'forgot-password',
      minWidth: '350px',
      minHeight: '20vh',
      width: '35vw',
      maxWidth: '90%',
    });

    return dialogRef;
  }

  signUp(data: any): Promise<any> {
    return lastValueFrom(this.http.post(`${this.config.API_BASE}/api/auth/signup`, {
      ...data,
      roleName: 'ROLE_HOST_ADMIN'
    }));
  }

  login(data: any): Promise<any> {
    return lastValueFrom(this.http.post(`${this.config.API_BASE}/api/auth/signin`, data));
  }

  sendOTP(mobile: string, type = ''): Promise<any> {
    const data = {
      userName: mobile,
      otpType: 'MOBILE',
      type,
    };

    return lastValueFrom(this.http.post(`${this.config.API_BASE}/api/v1/otp/generateForLogin`, data));
  }

  getUserId(): any {
    try {
      const data = this.tokenServe.getProfileInfo();
      return data.user.id
    } catch (error) {

    }
  }

  getBussinessId(): any {
    return this.tokenServe.getBusinessId();
  }

  async getProfileInfo(): Promise<any> {
    try {
      const data = await lastValueFrom(this.http.get(`${this.config.API_BASE}/api/auth/profileInfo`));
      this.tokenServe.setLoginData(data);
      return data;
    } catch (error) {
      console.error(error, 'Failed to retrive the profile info');
      return null;
    }
  }

  public get isLoggedIn() {
    return this.tokenServe.isLoggedIn()
  }

  logout() {
    this.tokenServe.logout();
  }

  activateAccount(token: string): Promise<any> {
    const url = `${this.config.API_BASE}/api/auth/activate/${token}`;
    return lastValueFrom(this.http.get(url));
  }

  sendPasswordResetLink(email: string): Promise<any> {
    const url = `${this.config.API_BASE}/api/auth/resetPassword`;
    return lastValueFrom(this.http.post(url, {}, { params: { email } }));
  }

  resetPassword(newPassword: string, token: string): Promise<any> {
    const url = `${this.config.API_BASE}/api/auth/resetPassword/${token}`;
    return lastValueFrom(this.http.post(url, { token, newPassword }));
  }
}
